import Vue from 'vue'

export default {}
export const EventBus = new Vue()
